import { useTimeZoneContext } from '@ais-ui/utils';
import {
  useCompleteReportFetchingProcess,
  useGetExtraJobData,
} from '@ais-ui/websockets';
import { useMapPanelContext } from '../Map/MapPanel/MapPanelContext';
import { useMapReportOverlay } from './useMapReportOverlay';
import { useEffect } from 'react';
import { CENTERCOMPONENTS } from '../Map/MapPanel/CenterComponents';

export const useManageReportProcessing = (jobId: string, zoom: boolean) => {
  const { timeZone } = useTimeZoneContext();
  const {
    data: reportResult,
    isLoading: reportLoading,
    isError: reportError,
  } = useCompleteReportFetchingProcess(jobId, timeZone);
  const {
    data: shipData,
    isLoading: shipDataLoading,
    isError: shipDataError,
  } = useGetExtraJobData(jobId, timeZone, -360, 360, -360, 360);

  const {
    setCenterComponent,
    setCenterComponentData,
    setLoadingCenterComponentData,
  } = useMapPanelContext();

  useMapReportOverlay(jobId, zoom ? reportResult?.imageExtent : undefined);

  useEffect(() => {
    // Check if either query is loading or has an error
    const isLoading = shipDataLoading || reportLoading;
    const isError = shipDataError || reportError;

    setLoadingCenterComponentData(isLoading);

    if (shipData !== undefined) {
      // shipData has been loaded (could be empty array)
      setCenterComponentData(shipData);
      setCenterComponent(CENTERCOMPONENTS.SHIPTABLE);
    }
    // The SQL and ships report doesn't have data in shipData. We have to check if there's shipdata, if there is it wins
    if (reportResult?.shipData !== undefined && shipData?.length === 0) {
      // Fall back to reportResult.shipData if shipData is undefined
      setCenterComponentData(reportResult.shipData);
      setCenterComponent(CENTERCOMPONENTS.SHIPTABLE);
    }
  }, [
    shipData,
    reportResult,
    shipDataLoading,
    reportLoading,
    shipDataError,
    reportError,
    setCenterComponent,
    setCenterComponentData,
  ]);

  return reportResult;
};
